<template>
<el-row class="cs-contentContainer" v-loading="true">
    <el-col>

    </el-col> 
</el-row>
  
</template>

<style lang="scss" scoped>

</style>

<script>
import {
  compileStr,
  uncompileStr,
  getStore
} from '../../config/mUtils'
import { userLogin, validateToken } from "../../service/user.service";

export default {
  props: {
    
  },
  data() {
    return {
       
    };
  },
  beforeCreate(){
    try{
     window.parent.postMessage(
        {
          cmd: "wechatHandler",
        },
        "*"
      );
    }catch(e){

    }
  },
  created() {
     this.sendMsg();
    this.handleWechatCallback();
  },
  methods: {
    sendMsg() {
      window.parent.postMessage(
        {
          cmd: "wechatHandler",
        },
        "*"
      );
    },
    async handleWechatCallback(){
      let result = {success: false, code:"", action:"", message: ""};
      let code = this.$route.query.code;
      let state = this.$route.query.state;
     
      if (!state){
        return;
      }
      state = state.replace(/{}/g, '"');
      //console.log("state",state);
      let stateObj = JSON.parse(state);
      if (!code){
          result.message = "取消微信授权，验证失败";
      }else{
        let token = stateObj.token;
     
        let validation = await validateToken(token);
        if (!!validation && validation.success){
            result.success = true;
            result.code = code;
            result.action = stateObj.action;
        }else{
          result.message = "用户登录已过期，验证失败";
        }
      }

      let str = JSON.stringify(result);
      let redirectUrl = stateObj.url + "?data=" + str;
      //console.log("redirectUrl",redirectUrl);
      window.location.href = redirectUrl;
    }
   
  },
  watch: {
   
  }
};
</script>
 



// WEBPACK FOOTER //
// src/page/wechat/wechatHandler.vue